import React from 'react';
import { COMPANY_INFO } from '../data/company';

export function FloatingContactActions() {
  return (
    <aside className="fixed right-0 top-1/2 z-[60] flex -translate-y-1/2 flex-col gap-3" aria-label="Hurtig kontakt">
      <a
        href={`tel:${COMPANY_INFO.phoneRaw}`}
        aria-label="Ring til JNO Montage"
        className="grid h-12 w-12 place-items-center rounded-xl bg-[#006DDE] text-base text-white shadow-lg shadow-[#006DDE]/25 transition hover:bg-[#0058b4] sm:h-14 sm:w-14 sm:text-lg"
      >
        <i className="fa-light fa-phone" aria-hidden="true" />
      </a>
      <a
        href={`mailto:${COMPANY_INFO.email}`}
        aria-label="Skriv til JNO Montage"
        className="grid h-12 w-12 place-items-center rounded-xl bg-[#006DDE] text-base text-white shadow-lg shadow-[#006DDE]/25 transition hover:bg-[#0058b4] sm:h-14 sm:w-14 sm:text-lg"
      >
        <i className="fa-light fa-envelope" aria-hidden="true" />
      </a>
    </aside>
  );
}
